import React from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import { AccessibilityFilled } from '@sis-cc/dotstatsuite-visions/Icons/AccessibilityFilled';
import { AccessibilityOutlined } from '@sis-cc/dotstatsuite-visions/Icons/AccessibilityOutlined';
import { Tooltip } from '@sis-cc/dotstatsuite-visions/Tooltip';
import { FormattedMessage, formatMessage } from '../i18n';
import { useHasAccessibility } from '../hooks/router';
import { useAppNavigation } from '../hooks/navigation/useAppNavigation';
import messages from './messages';
import useTooltip from '../hooks/useTooltip';

const AccessibilityButton = () => {
  const { changeHasAccessibility } = useAppNavigation();
  const intl = useIntl();
  const hasAccessibility = useHasAccessibility();
  const { open, onOpen, onClose } = useTooltip();

  return (
    <Tooltip
      placement="bottom"
      variant="light"
      title={
        <Container>
          {hasAccessibility ? (
            <FormattedMessage id="accessibility.disable" />
          ) : (
            <FormattedMessage id="accessibility.enable" />
          )}
        </Container>
      }
      open={open}
      onOpen={onOpen}
      onClose={onClose}
    >
      <IconButton
        aria-label={
          hasAccessibility
            ? formatMessage(intl)(messages.accessibilitySupportEnabled)
            : formatMessage(intl)(messages.accessibilitySupportDisabled)
        }
        aria-pressed={hasAccessibility}
        onClick={() => changeHasAccessibility(!hasAccessibility)}
        size="large"
      >
        {hasAccessibility ? (
          <AccessibilityFilled color="primary" />
        ) : (
          <AccessibilityOutlined color="primary" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default AccessibilityButton;
